import React from 'react';

import { useWatch } from 'react-hook-form';

import Input from 'components/Input/Input';
import Switch from 'components/Switch/Switch';
import Typography from 'components/Typography/Typography';
import { FormField } from 'components/ui';

import { EventRowProps } from '../types';

export const EventRow: React.FC<EventRowProps> = ({
  control,
  label,
  nameField,
  enabledField,
  error,
  disabled = false,
  switchSyncKey,
  testIdPrefix
}) => {
  const isEventEnabled = useWatch({ control, name: enabledField });

  return (
    <div className="flex flex-col gap-2 mb-5">
      <Typography className="text-sm font-medium text-base-foreground">
        {label}
      </Typography>
      <div className="flex items-center gap-3">
        <div className="flex-1">
          <FormField
            control={control}
            name={nameField}
            render={({ field: { value, onChange, onBlur } }) => (
              <Input
                name={nameField}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                disabled={disabled || !isEventEnabled}
                placeholder="Enter event name"
                state={error ? 'error' : 'default'}
                inputClassName={error ? 'border-base-destructive' : undefined}
                description={error}
                dataTestId={`${testIdPrefix}-name`}
              />
            )}
          />
        </div>
        <FormField
          control={control}
          name={enabledField}
          render={({ field: { value, onChange } }) => (
            <Switch
              key={`${testIdPrefix}-${value ? 'on' : 'off'}-${switchSyncKey}`}
              defaultChecked={value}
              checked={value}
              onCheckedChange={onChange}
              disabled={disabled}
              size="md"
              switchClassName="data-[state=checked]:bg-indigo-700"
              data-testid={`${testIdPrefix}-toggle`}
            />
          )}
        />
      </div>
    </div>
  );
};
